<template>
  <div class="tab-pane">
    <div class="mb-3">
      <div class="row">
        <div class="col">
          <label
            for="categories"
            class="form-label"
          >
            {{ $t("gpool.form_category") }}
          </label>
          <select
            name="categories"
            id="categories"
            class="form-control"
            v-model="selected_category"
          >
            <option value="">{{ $t("gpool.form_all") }}</option>
            <option
              v-for="category in categories"
              :key="category.id"
              :value="category.id"
            >
              {{ category.name }}
            </option>
          </select>
        </div>
        <div class="col">
          <label
            for="categories"
            class="form-label"
          >
            {{ $t("gpool.form_company") }}
          </label>
          <select
            name="companies"
            id="companies"
            class="form-control"
            v-model="selected_company"
          >
            <option value="">{{ $t("gpool.form_all") }}</option>
            <option
              v-for="company in companies"
              :key="company.id"
              :value="company.id"
            >
              {{ company.name }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="mb-3">
      <div class="row">
        <div class="col">
          <label for="games">{{ $t("gpool.search_game") }}</label>
          <Select2
            v-model="selected_game"
            :options="siteGames.map(c => ({ id: c.id, text: c.name }))"
          />
        </div>
      </div>
    </div>
    <div
      class="my-2"
      v-if="selected_games.length"
    >
      <button
        class="btn btn-primary"
        @click="removeBatch"
      >
        {{ $t("gpool.remove_selected_games") }} ({{ selected_games.length }})
      </button>
    </div>
    <table class="table table-striped table-bordered">
      <thead>
        <tr>
          <th @click="selectAllGames">
            <input
              type="checkbox"
              style="pointer-events: none"
              :checked="
                siteGames.length > 0 &&
                selected_games.length === siteGames.length
              "
            />
          </th>
          <th>ID</th>
          <th>{{ $t("gpool.table_name") }}</th>
          <th>{{ $t("gpool.table_status") }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="game in siteGames">
          <td @click="selectGame(game.id)">
            <input
              type="checkbox"
              style="pointer-events: none"
              :checked="selected_games.includes(game.id)"
            />
          </td>
          <td>{{ game.id }}</td>
          <td width="100%">
            {{ game.name }}
          </td>
          <td>
            <div
              class="form-switch"
              @click="
                toggleSiteGameStatus({
                  site_id: $route.params.id,
                  game_id: game.id,
                  status: !game.owned_status
                })
              "
            >
              <input
                type="checkbox"
                class="form-check-input"
                id="status"
                style="pointer-events: none"
                :disabled="statusing"
                :checked="game.owned_status"
              />
            </div>
          </td>
          <td>
            <button
              class="btn btn-secondary"
              @click="remove(game.id)"
            >
              <i class="fa fa-minus"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Select2 from "v-select2-component";
export default {
  name: "SiteGamesGames",
  components: {
    Select2
  },
  computed: {
    ...mapGetters("site", ["siteGames", "statusing"]),
    ...mapGetters("category", ["categories"]),
    ...mapGetters("company", ["companies"])
  },
  mounted() {
    this.getSiteGames({ site_id: this.$route.params.id });
  },
  methods: {
    selectAllGames() {
      if (this.selected_games.length === this.siteGames.length) {
        this.selected_games = [];
      } else {
        this.selected_games = this.siteGames.map(game => game.id);
      }
    },
    selectGame(id) {
      if (this.selected_games.includes(id)) {
        this.selected_games = this.selected_games.filter(
          game_id => game_id !== id
        );
      } else {
        this.selected_games.push(id);
      }
    },
    async removeBatch() {
      await this.removeGameBatch({
        site_id: this.$route.params.id,
        game_ids: this.selected_games
      });
      this.selected_games = [];
    },
    async remove(game_id) {
      await this.removeGame({ site_id: this.$route.params.id, game_id });
      this.selected_game = "";
    },
    ...mapActions("site", [
      "getSiteGames",
      "removeGame",
      "toggleSiteGameStatus",
      "removeGameBatch"
    ])
  },
  data() {
    return {
      selected_games: [],
      selected_game: "",
      selected_category: "",
      selected_company: ""
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/siteGames/SiteGamesGames.vue